<template>
  <div class="page">
    <div style="margin-bottom: 16px">
      提示：鼠标悬浮到条目上后，按住鼠标并上下滑动即可调整排序
    </div>
    <!--使用draggable组件 todo-->
    <draggable
      v-model="queueList"
      chosenClass="chosen"
      forceFallback="true"
      group="people"
      animation="1000"
    >
      <transition-group>
        <div
          class="item"
          v-for="element in queueList"
          :key="element.id"
          :class="'element'"
        >
          <div>{{ element.name }}</div>
          <div class="box_62 flex-col"></div>
        </div>
      </transition-group>
    </draggable>

    <div class="edit" @click="editPanelQueue()">保存</div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { getPanelQueue, editPanelQueue } from "@/api/api";
export default {
  components: { draggable },
  data() {
    return {
      queueList: [],
      queueId: "",
    };
  },
  mounted() {
    this.getPanelQueue();
  },
  methods: {
    getPanelQueue() {
      getPanelQueue().then((res) => {
        // todo
        let data = res.data.data;
        this.queueId = data.id;
        let nameList = data.typeName.split(",");
        let idList = data.typeId.split(",");
        let keyList = data.solrKey.split(",");

        if (nameList.length === nameList.length) {
          nameList.map((item, index) => {
            let obj = {
              id: idList[index],
              name: item,
              solrKey: keyList[index],
            };
            this.queueList.push(obj);
          });
        } else {
          this.$message.error("栏目查询出错");
          return;
        }
      });
    },
    editPanelQueue() {
      let params = {
        id: this.queueId,
        typeName: "",
        typeId: "",
      };
      this.queueList.map((item) => {
        params.typeName += item.name + ",";
        params.typeId += item.id + ",";
      });
      params.typeName = params.typeName.slice(0, params.typeName.length - 1);
      params.typeId = params.typeId.slice(0, params.typeId.length - 1);
      editPanelQueue({ ...params }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("调整栏目顺序成功");
          this.$store.commit("setIsModify", false);
        } else {
          this.$message.error("调整栏目顺序失败");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  height: 100%;
}

.item {
  cursor: move;
  padding: 12px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  .box_62 {
    width: 16px;
    height: 16px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng76ab518d1128cec553e3d07026fb386be140900a9fb99b49d4dd6de5595b568c)
      100% no-repeat;
    background-size: 100% 100%;
  }
}
/*选中样式*/
.chosen {
  border: solid 2px #3089dc !important;
}

.edit {
  width: 80px;
  height: 30px;
  line-height: 30px;
  margin: 10px 0;
  text-align: center;
  border: 1px solid #0d6ec4;
  border-radius: 4px;
  color: #0d6ec4;
  cursor: pointer;
}
</style>
